import React, { useEffect, useState } from 'react';
import { StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';
import { Text, View } from '../Themed';

export interface DSCheckBoxProps {
  width?: string;
  height?: string;
  descHeader: string;
  description?: string;
  label?: string;
  onPress: any;
  selected?: boolean;
  containerStyle?: ViewStyle;
  innerContainer?: ViewStyle;
}
export default function DSCheckBoxWithDescription(svgProps: DSCheckBoxProps) {
  useEffect(() => {
    setIsSelected(svgProps.selected);
  }, [svgProps.selected]);

  const [isSelected, setIsSelected] = useState(svgProps.selected);
  const innerPress = () => {
    let newValue = !isSelected;
    setIsSelected(newValue);
    svgProps.onPress(newValue);
  };

  let xmlNotSelected = (
    <svg width="24" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="20" height="20" rx="3" stroke="#6C757D" stroke-width="2" />
    </svg>
  );

  let xmlSelected = (
    <svg width="22" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#093F76" />
      <path
        d="M10.125 17.0001C9.95932 16.9978 9.80049 16.9338 9.67966 16.8204L5.30466 12.4454C5.205 12.324 5.15407 12.1698 5.16177 12.0129C5.16948 11.856 5.23527 11.7076 5.34636 11.5965C5.45744 11.4854 5.60587 11.4196 5.76278 11.4119C5.91969 11.4042 6.07385 11.4551 6.19529 11.5548L10.125 15.4923L18.4297 7.17979C18.5511 7.08012 18.7053 7.02919 18.8622 7.0369C19.0191 7.0446 19.1675 7.1104 19.2786 7.22148C19.3897 7.33256 19.4555 7.481 19.4632 7.6379C19.4709 7.79481 19.42 7.94898 19.3203 8.07041L10.5703 16.8204C10.4495 16.9338 10.2906 16.9978 10.125 17.0001Z"
        fill="white"
      />
    </svg>
  );

  return (
    <TouchableOpacity style={[styles.container, svgProps?.containerStyle]} onPress={innerPress}>
      <View style={styles.buttonContainer}>{isSelected ? xmlSelected : xmlNotSelected}</View>
      <View style={[{ width: '100%', marginLeft: 16 }, svgProps.innerContainer]}>
        {svgProps.descHeader && <Text style={styles.descHeader}>{svgProps.descHeader}</Text>}
        {svgProps.description && <Text style={styles.description}>{svgProps.description}</Text>}
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  buttonContainer: {
    marginLeft: 0,
  },
  descHeader: {
    fontFamily: 'Jost Regular',
    fontSize: 16,
    fontWeight: '500',
    color: '#000000',
  },
  description: {
    fontFamily: 'Jost Regular',
    fontSize: 18,
    color: '#6c7570',
  },
  container: {
    alignItems: 'center',
    marginTop: 20,
    marginBottom: 0,
    flexDirection: 'row',
  },
});
